import { CompanyReportAdminTranslation } from '../../constants';
import { CompanyReportItem } from '../types-store';
import { ExcelMappingParam } from '../types';
import { ComplexValue } from 'ui';

export const getExcelMappingText = (id: string, translation: CompanyReportAdminTranslation): string => {
  return {
    [ExcelMappingParam.favouriteCondition]: translation.excel_mappings_group_favourite_condition,
    [ExcelMappingParam.favouriteConditionValue]: translation.excel_mappings_group_favourite_condition_value,
    [ExcelMappingParam.generationTime]: translation.excel_mappings_group_generate_time,
    [ExcelMappingParam.period]: translation.excel_mappings_group_period,
    [ExcelMappingParam.searchParameters]: translation.excel_mappings_group_search_parameters,
    [ExcelMappingParam.urlForWebApplication]: translation.excel_mappings_group_url
  }[id];
};

export const emailBodyFieldsRequired = (companyReportItem: CompanyReportItem) =>
  !!(companyReportItem?.textSet?.value || companyReportItem?.textId || companyReportItem?.textDescription);

export const getOnlyExistedValues = (value: ComplexValue<number>) => !!value && JSON.parse(JSON.stringify(value));
